import { Typography } from '@ui-components/neo.tax';

import { useOnboardingFlowCompletionPercent } from '@neo.tax/shared/hooks';

import { AnalysisHero } from '../analysis-hero';

export const OnboardingFlowProcessingHero = (): React.ReactElement => {
  const { percentCompleted } = useOnboardingFlowCompletionPercent();

  return (
    <AnalysisHero
      title={
        <>
          <Typography as="span" fontSize="4xl" fontWeight="bold" color="white">
            WHOA Speed Demon!
          </Typography>{' '}
          <br />
          <Typography as="span" fontSize="4xl" fontWeight="normal" color="white">
            Neo.Tax is{' '}
            <Typography as="span" fontWeight="bold" fontSize="4xl" color="white">
              {percentCompleted}%
            </Typography>{' '}
            through analyzing your data
          </Typography>
        </>
      }
    />
  );
};
